import pluralize from 'pluralize';
import React from 'react';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import TaskDetails from './TaskDetails';

export default function BulkArchive({ projectId, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Archive"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projects(projectId)
          .tasks()
          .bulkSetRecordStatus(ids, { recordStatusId: 'archived' })
          .then((r) => r.data)
      }
      renderRow={TaskDetails}>
      {`Are you sure you want to archive ${ids.length} ${pluralize('task', ids.length)}? Running timers on selected tasks will be stopped.`}
    </BulkActionModal>
  );
}
